import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {addTopRatedMovies} from '../utils/MovieSlice'
import {API_OPTIONS} from '../utils/Constants'



const useTopRated = () =>{
   
  const dispatch = useDispatch();

 

  const getTopRatedMovies = async () =>{
  const data = await fetch('https://api.themoviedb.org/3/movie/top_rated?page=1', API_OPTIONS)
  const json = await data.json();
  dispatch(addTopRatedMovies(json.results)); 

}

useEffect(()=>{
  getTopRatedMovies()
},[])}

export default useTopRated;